<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="sku" label="Sku" outlined dense rounded disabled></v-text-field>
                </v-col>                
                <v-col cols="4">
                    <v-text-field class='text-caption' v-model="producto" label="Producto" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-btn @click="openProducto()" class="mt-1" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col>
                <v-col cols="3">
                    <v-alert class='text-caption' v-if="existe=='si'" dense text type="success">
                        Existe !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else-if="existe=='no'" dense text type="warning">
                        Nueva !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else dense text type="info">
                        Selecciona Producto !!!
                    </v-alert>
                </v-col >
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="categoria" label="Categoria" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="marca" label="Marca" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field class='text-caption' v-model="variante" label="Variante" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="pro_medida" label="Medida" outlined dense rounded disabled></v-text-field>
                </v-col>
            </v-row>
            <v-divider class="mt-n5"></v-divider>
            <v-row class="mt-1">
                <v-col cols="2" class="text-center">
                    <v-radio-group class="mt-1" v-model="tipo">
                        <v-radio label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="4" class="d-flex">
                    <v-text-field class='text-caption' v-model="material" label="Material" outlined dense rounded disabled></v-text-field>
                    <v-btn @click="openMaterial()" class="mt-1 ml-2" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="mat_medida" label="Medida" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="precio" label="Costo Medida" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2" class="d-flex">
                    <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="cantidad" label="Cantidad" outlined dense rounded></v-text-field>
                    <v-btn class="ml-2" icon><v-icon @click="agregar()" color="indigo">add_circle_outline</v-icon></v-btn>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="12">
                    <v-container>
                        <v-simple-table fixed-header height="225" dense class="myborder">
                            <thead>
                                <tr>
                                    <th id="back-blue" class="text-center" style="width: 15%;">Codigo</th>
                                    <th id="back-blue" class="text-start" style="width: 25%;">Material</th>
                                    <th id="back-blue" class="text-start" style="width: 20%;">Variante</th>
                                    <th id="back-blue" class="text-center" style="width: 10%;">Medida</th>
                                    <th id="back-blue" class="text-center" style="width: 10%;">Costo Medida</th>
                                    <th id="back-blue" class="text-center" style="width: 10%;">Cantidad</th>
                                    <th id="back-red" class="text-center" style="width: 10%;">Total</th>
                                    <th id="back-blue">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in desserts" :key="item.id">
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.codigo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.producto }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.variante }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.medida }}</span>
                                    </td>
                                    <td class="text-end">
                                        <span class="text-caption">$ {{new Intl.NumberFormat("de-DE").format(parseFloat(item.costo))}}</span>
                                    </td>
                                    <td class="text-end">
                                        <span class="text-caption">{{new Intl.NumberFormat("de-DE").format(parseFloat(item.cantidad))}}</span>
                                    </td>
                                    <td class="text-end">
                                        <span class="text-caption">$ {{new Intl.NumberFormat("de-DE").format(parseFloat(item.total))}}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon @click="eliminar(item)" color="red" small>delete</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-container>
                </v-col>
            </v-row>
            <v-container>
                <v-row class="mt-n8">
                <v-col cols="3">
                    <v-alert style="height:40px;" class='text-body-2' dense text border="left" color="blue">
                        <div class="mt-1 float-left black--text">
                            Cantidad Items
                        </div>
                        <div class="mt-1 float-right black--text">
                            {{new Intl.NumberFormat("de-DE").format(total_productos)}}
                        </div>                                             
                    </v-alert>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2">
                    <v-btn @click="clsInput()" class="mt-2" color="teal" rounded dark small block>Nuevo</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn v-if="btn_grabar!=false" @click="saveReceta()" class="mt-2" color="teal" rounded dark small block>Grabar</v-btn>
                    <v-btn v-else class="mt-2" color="grey" rounded dark small block>Grabar</v-btn>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="3" class="text-end">
                    <v-alert style="height:40px;" class='text-body-2' dense text border="left" color="blue">
                        <div class="mt-1 float-left black--text">
                            Costo Total
                        </div>
                        <div class="mt-1 float-right black--text">
                            $ {{new Intl.NumberFormat("de-DE").format(total_neto)}}
                        </div>                                             
                    </v-alert>
                </v-col>
            </v-row>
            </v-container>
        </v-container>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="50%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProductos" dense dark 
                    :search="products_search" :headers="products_titulo" :items="filter_products" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
#back-blue {
    background-color: lightblue;
}
#back-red {
    background-color: rgb(250, 147, 109);
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Receta',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    snack:false,
    color_snack:'',
    mensaje:'',

    sku:'',
    producto:'',
    existe:'',
    tipo:'material',
    categoria:'',
    marca:'',
    variante:'',
    pro_medida:'',
    codigo:'',
    material:'',
    mat_variante:'',
    mat_medida:'',
    precio:'',
    cantidad:'',
    cambio:0,
    desserts:[],
    categorias:[],
    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Variante', align: 'start', sortable: true, value: 'variante' },
    ],
    products_lista: [],
    filter_products:[],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',
    select:'',
    total_productos:0,
    total_neto:0,
    numClicks:0,
    btn_grabar:true,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    await this.searchProducts();
    await this.searchCategory();
    this.bloqueo = await this.myPermiso(4);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async clsInput(){
        this.sku='';
        this.producto='';
        this.existe='';
        this.categoria='';
        this.marca='';
        this.variante='';
        this.pro_medida='';
        this.codigo='';
        this.material='';
        this.mat_variante='';
        this.mat_medida='';
        this.precio='';
        this.cantidad='';
        this.cambio=0;
        this.desserts=[];
        this.select='';
        this.total_productos=0;
        this.total_neto=0;
        this.numClicks=0;
        this.btn_grabar=true;
    },
    async searchProducts(){
        try {
            this.products_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async searchCategory(){
        try {
            this.categorias=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                categoria :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/category/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.categorias = datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async handleProductos(item){
        if(this.select=='pro'){
            this.clsInput();
            this.sku = item.codigo;
            this.producto = item.producto;
            const myCategory = this.categorias.filter(res => res.id == item.categoria);
            if(myCategory.length!=0){
                this.categoria =myCategory[0].categoria;
            } else {
                this.categoria = ''
            };
            this.marca = item.marca;
            this.variante = item.variante;
            this.pro_medida = item.medida;
        }
        if(this.select=='mat'){
            this.codigo = item.codigo;
            this.material = item.producto;
            this.mat_variante = item.variante;
            this.mat_medida = item.medida;
            if(item.medida=='UN'){ this.cambio=1 };
            if(item.medida=='MT'){ this.cambio=100 };
            if(item.medida=='KG'){ this.cambio=1000 };
            if(item.medida=='LT'){ this.cambio=1000 };            
            const promedio = await this.costoMaterial(item.codigo);
            const myPrecio = parseFloat(parseFloat(promedio)/parseFloat(this.cambio)).toFixed(0);
            this.precio = myPrecio;
        }
        this.d_products = false;
    },
    openProducto(){
        this.select='pro';
        this.filter_products = this.products_lista.filter(res => res.tipo!=this.tipo);
        this.d_products = true;
    },
    openMaterial(){
        this.select='mat';
        this.filter_products = this.products_lista.filter(res => res.tipo==this.tipo);
        this.d_products = true;
    },
    async costoMaterial(codigo){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                code :  codigo
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/cost/promedio/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseFloat(datos[0].promedio).toFixed(0);
            }
        } catch (error) {
            console.log(error)           
        }
        return result
    },
    onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    buscar(){
        this.producto='';
        this.codigo='';
        this.medida='';
        this.disabled=true;
        this.filled=true;
    },
    editar(){
        this.producto='';
        this.codigo='';
        this.medida='';
        this.disabled=false;
        this.filled=false;
    },
    async agregar(){
        if(this.material!='' && this.cantidad!='' && this.mat_medida!=''){
            //buscamos si ya existe el material
            const found = this.desserts.filter(res => res.codigo == this.codigo);
            if(found.length!=0){
                const new_cantidad = parseFloat(found[0].cantidad) + parseFloat(this.cantidad);
                const new_total = parseFloat(parseFloat(new_cantidad) * parseFloat(this.precio)).toFixed(2);
                found[0].cantidad = new_cantidad;
                found[0].total = new_total
            } else {
                const valor = parseFloat(parseFloat(this.precio)*parseFloat(this.cantidad)).toFixed(2);
                this.desserts.push({
                    codigo: this.codigo,
                    producto: this.material,
                    variante: this.mat_variante,
                    medida: this.mat_medida,
                    costo: this.precio,
                    cantidad: this.cantidad,
                    total: valor
                });
            };
            await this.totales();
            this.codigo='';
            this.material='';
            this.mat_variante='';
            this.mat_medida='';
            this.precio='';
            this.cantidad='';
        } else {
            this.mensaje='Ingrese producto';
            this.color_snack='red';
            this.snack=true;
        }
    },
    async totales(){
        let total_mat = this.desserts.length;
        let total_cost = 0;
        this.desserts.forEach(element => {
            total_cost = parseFloat(total_cost) + parseFloat(element.total);
        });
        this.total_productos = total_mat;
        this.total_neto = total_cost;
    },
    eliminar(line){
        this.desserts = this.desserts.filter(function(reg) {
            return reg.codigo !== line.codigo;
        });
        const found_code = this.desserts.filter(res => res.codigo == line.codigo);
        if(found_code.length==0){
            this.total_productos = parseFloat(this.total_productos) - 1;
            this.total_neto = parseFloat(this.total_neto) - parseFloat(line.total);
        }
    },
    async saveReceta(){
        this.loading=true;
        try {
            this.numClicks++;
            if(parseInt(this.numClicks)==1){
                if(parseFloat(this.total_productos)!=0 && this.sku!=''){
                    //crear array de compras
                    const array_receta = {
                        sku: this.sku,
                        products: this.desserts
                    }
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        receta: array_receta
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/receta/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        this.color_snack='success';
                        this.mensaje='La receta fue grabada con exito';
                        this.snack=true
                        this.btn_grabar=false;
                    } else {
                        this.color_snack='error';
                        this.mensaje='La receta no fue grabada';
                        this.snack=true
                    }   
                } else {
                    this.color_snack='error';
                    this.mensaje='No existen datos para continuar';
                    this.snack=true
                }
            } else {
                this.numClicks=0;
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    }
  }
}
</script>
